























































import { cloneDeep, isEqual } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { PlaceholdersOnes, PlaceholdersStack } from "../../../../../components/Editor/components/Toolbar/types";
import {
  AvailableButtonsTypes
} from "../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import { warningNotificationWrapper } from "../../../../../logic/helpers/NotificationService";
import { SelectOption } from "../../../../../logic/types";
import { UserActivationActionTypeEnum } from '../../ActivationAction';
import { LocalAutoReplyAction } from '../types'
import ActionCardAction from './ActionCardAction.vue'
import ActionCardConditions from './ActionCardConditions.vue'

@Component({
  components: {
    ActionCardConditions,
    ActionCardAction,
  }
})
export default class ActionCard extends Vue {
  @Prop({ type: Boolean, default: false }) commandsConditions!: boolean

  @Prop() action!: LocalAutoReplyAction

  @Prop() flowOptions!: Array<SelectOption>

  @Prop() emptyFlowButtonCallback!: () => void

  @Prop() boardKey!: string

  @Prop() placeholders!: PlaceholdersOnes | PlaceholdersStack

  @Prop() editorButtons!: AvailableButtonsTypes

  @Prop() limitTypes!: Array<UserActivationActionTypeEnum>

  @Emit()
  saveAction(action: LocalAutoReplyAction) {
    return action
  }

  @Emit()
  removeAction(guid: string) {
    return guid
  }

  @Watch('action')
  onActionChange() {
    this.updateActionCopy()
  }

  actionCopy: LocalAutoReplyAction | null = null

  get isValid(): boolean {
    return this.conditionsIsValid && this.isActionValid
  }

  get conditionsIsValid(): boolean {
    return !!this.actionCopy && this.actionCopy.conditions.every((g) => g.value.length && g.value.every((c) => c.value.values.length))
  }

  get isActionValid(): boolean {
    if (this.actionCopy) {
      if (this.actionCopy.action.type === UserActivationActionTypeEnum.Message) {
        const { variants } = this.actionCopy.action

        return !!variants.length && (!!variants[0].text.trim() || !!variants[0].attachments.length)
      } else {
        return !!this.actionCopy.action.flow
      }
    }

    return false
  }

  get isChanged(): boolean {
    return !isEqual(this.action, this.actionCopy)
  }

  saveClickHandler(): void {
    if (this.isValid) {
      if (this.actionCopy) {
        this.saveAction(this.actionCopy)
      }
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('set_data_warning_alert').toString())
    }
  }

  updateActionCopy() {
    this.actionCopy = cloneDeep(this.action)
  }

  created(): void {
    this.updateActionCopy()
  }
}
